import { originatesFromRemoteBackendAgent, type Transaction } from '@canvas/transaction';

interface GetBackendAgentDeletedFieldIdsOptions {
  currentFieldIds: readonly string[];
  previousFieldIds: readonly string[];
  transaction: Transaction;
}

export function getBackendAgentDeletedFieldIds({
  currentFieldIds,
  previousFieldIds,
  transaction
}: GetBackendAgentDeletedFieldIdsOptions): readonly string[] {
  if (!originatesFromRemoteBackendAgent(transaction)) {
    return [];
  }

  const currentFieldIdSet = new Set(currentFieldIds);
  return previousFieldIds.filter((fieldId) => !currentFieldIdSet.has(fieldId));
}

export function isFieldOrderingChangeDeletionOnly({
  currentFieldIds,
  deletedFieldIds,
  previousFieldIds
}: {
  currentFieldIds: readonly string[];
  deletedFieldIds: readonly string[];
  previousFieldIds: readonly string[];
}): boolean {
  const deletedFieldIdSet = new Set(deletedFieldIds);
  const retainedFieldIds = previousFieldIds.filter(
    (fieldId) => !deletedFieldIdSet.has(fieldId)
  );

  return (
    retainedFieldIds.length === currentFieldIds.length &&
    retainedFieldIds.every((fieldId, index) => fieldId === currentFieldIds[index])
  );
}
